import FetchUtils from '../utils/fetch.utils';

export default class TransferService {
  static BASE_URL = `${process.env.PREACT_APP_API_DOMAIN_TRANSFERS}/api/transfers`;
  static BASE_POS_URL = `${process.env.PREACT_APP_API_DOMAIN_TRANSFERS}/api/basata/transfer`;

  static sendMoney = async (
    idempotencyKey,
    cardUidFrom,
    cardUidTo,
    currency,
    amount,
    transferReasonCode
  ) => {
    const body = {
      cardUidFrom,
      cardUidTo,
      amount: Number(amount),
      currency,
      reason: 'SEND_MONEY',
      transferReasonCode,
      metadata: {
        transferMotive: transferReasonCode
      }
    };
    return FetchUtils.post(
      TransferService.BASE_URL,
      body,
      { headers: { 'x-idempotency-key': idempotencyKey } },
    );
  };

  static accreditMoney = async (
    idempotencyKey,
    amount,
    merchantId,
    organizationCode,
  ) => {
    const body = {
      amount: amount,
      merchantId: merchantId,
      organizationCode: organizationCode,
    };

    return FetchUtils.post(TransferService.BASE_POS_URL, body, {
      headers: { 'x-idempotency-key': idempotencyKey },
    });
  };

  static sendMoneyToCompany = async (
    idempotencyKey,
    organizationCodeTo,
    currency,
    amount,
  ) => {
    return FetchUtils.post(
      TransferService.BASE_URL,
      {
        organizationCodeTo: organizationCodeTo,
        amount: Number(amount),
        currency: currency,
        reason: 'SEND_MONEY_TO_COMPANY',
      },
      { headers: { 'x-idempotency-key': idempotencyKey } },
    );
  };
}
